module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-blue-a3ccc5899087bba44585dfd2dbd25444.png";